import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Paper,
  useTheme,
} from "@mui/material";
import axios from "axios";
import ipconfig from "../Core/ipconfig";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { encryptData } from "../Core/util/obfuscate";

const Login = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `${ipconfig}/adminpanel/login`,
        {
          email: email.toLowerCase().trim(),
          password: password,
        }
      );
      if (response.status === 200) {
        const token = response?.data?.token;
        localStorage.setItem("token", token);
        localStorage.setItem("name", response?.data?.name);
        localStorage.setItem("phone", response?.data?.phone);
        
        // Fetch and cache the Me details (permissions & profile info)
        try {
          const meResponse = await axios.get(`${ipconfig}/adminpanel/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (meResponse.status === 200 && meResponse.data?.status) {
            localStorage.setItem("adminMe", encryptData(meResponse.data.data));
          }
        } catch (meError) {
          console.error("Error fetching permissions on login:", meError);
        }

        navigate("/user");
        toast.success("Logged in successfully.", {
          position: "top-center",
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.log(error, "Error");
      toast.error("Login Failed.", {
        position: "top-center",
        autoClose: 1000,
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
        background: theme.palette.mode === "light"
          ? "radial-gradient(circle at 50% 50%, #f0f7ff 0%, #e2e8f0 100%)"
          : "radial-gradient(circle at 50% 50%, #1e293b 0%, #0f172a 100%)",
        boxSizing: "border-box",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: { xs: "90%", sm: "400px" },
          padding: "40px 32px",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          textAlign: "center",
          backgroundColor: "background.paper",
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "primary.main",
              letterSpacing: "-1px",
              mb: 1,
            }}
          >
            Accosync
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontWeight: 500,
            }}
          >
            Administrator Login Portal
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <TextField
            variant="outlined"
            label="Email Address"
            placeholder="Enter email address"
            size="medium"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            InputProps={{
              style: { borderRadius: "10px" }
            }}
          />
          <TextField
            variant="outlined"
            label="Password"
            placeholder="Enter password"
            size="medium"
            type={visible ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            InputProps={{
              style: { borderRadius: "10px" },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setVisible(!visible)}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            sx={{
              py: 1.5,
              borderRadius: "10px",
              fontSize: "16px",
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Login
          </Button>
        </Box>
      </Paper>
      <ToastContainer />
    </Box>
  );
};

export default Login;
